import { addDisplayName, addHandlers, addStateHandlers, flowMax } from 'ad-hok'
import { FC } from 'react'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { TextFieldNew } from '../TextField'
import { Brand, BrandSearch } from './BrandSearch'

interface Props {
  brand: Brand | undefined
  className?: string
  onChange: (brand: Brand | undefined) => void
  error?: string
}

export const BrandField: FC<Props> = flowMax(
  addDisplayName('BrandField'),
  addStateHandlers(
    {
      isShowingSearch: false,
    },
    {
      onFocus: () => () => ({
        isShowingSearch: true,
      }),
      onEndSearch: () => () => ({
        isShowingSearch: false,
      }),
    }
  ),
  addHandlers({
    onSelectFromSearch:
      ({ onEndSearch, onChange }) =>
      (brand: Brand) => {
        onEndSearch()
        onChange(brand)
      },
    onClear:
      ({ onChange, onFocus }) =>
      () => {
        onFocus()
        onChange(undefined)
      },
  }),
  addTranslationHelpers,
  ({
    brand,
    onFocus,
    onSelectFromSearch,
    isShowingSearch,
    onEndSearch,
    error,
    onClear,
    className,
    t,
  }) => (
    <>
      <TextFieldNew
        label={t('admin.product.fields.brand')}
        value={brand?.name}
        onChange={() => {}}
        onFocus={onFocus}
        noMargin
        className={className}
        error={error}
        onClear={onClear}
      />
      {isShowingSearch && (
        <BrandSearch onSelect={onSelectFromSearch} onCancel={onEndSearch} />
      )}
    </>
  )
)
